import {catchError, shareReplay} from 'rxjs/operators';
import {Config} from '@/config';
import {Observable} from 'rxjs';
import {AjaxResponse} from 'rxjs/ajax';

/* tslint:disable:only-arrow-functions */
function decorateObservable<T>(decorator: (x: Observable<T>) => Observable<T>) {
  return function(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function(...args: any[]) {
      return decorator(originalMethod.apply(this, args));
    };
    return descriptor;
  };
}

export function catchUnathorized() {
  return decorateObservable<AjaxResponse>((x) => x.pipe(catchError((error) => {
    // Unauthorzed, or expired token, let's refresh the page for now
    if (error.status === 401) {
      // TODO: introduce token refresh method to API
      setTimeout(() => window.location.reload(), Config.reloadTimeoutOnExpiredToken);
    }
    throw Error('401 Unauthorized');
  })));
}

interface Cache {
  [key: string]: {};
}
const cache: Cache = {};

export function cacheObservableData() {
  return function(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function(...args: any[]) {
      const argumentsKey = JSON.stringify(args);
      const cacheKey = `${target.constructor.name}_${propertyKey}_${argumentsKey}`;
      if (!cache[cacheKey]) {
        cache[cacheKey] = originalMethod.apply(this, args)
          .pipe(shareReplay(1));
      }
      return cache[cacheKey];
    };
    return descriptor;
  };
}
/* tslint:disable:only-arrow-functions */
